import React, { useEffect, useContext, useRef, useState } from "react";
import { Avatar, Box, Chip, CircularProgress, Grid, Paper, Typography } from "@mui/material";
import ApiService from "../../functions/apiService";
import MyTable from "../../components/Schedule/MyTable";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { toast } from 'react-toastify';
import moment from "moment";

export default function WatchParty() {
	const { user } = useContext(AuthContext);
	const [loading, setLoading] = useState(true);
	const [rows, setRows] = useState([]);
	const [allowedVars, setAllowedVars] = useState({})

	let getAllowedVars = () => {
		ApiService.get('/v3Variables')
			.then((res) => {
				setAllowedVars(res?.data?.data)
			}).catch(({ error }) => {
				console.log('error', error)
			});
	}

	useEffect(() => {
		getAllowedVars();
	}, [])

	let columns = [
		{
			field: 'Batch_Number', headerName: 'Batch', flex: 1, minWidth: 160, maxWidth: 160,
			cellClassName: 'space-cutter-class', filterable: false,
		},
		// {
		// 	field: 'patch_id', headerName: 'Patch Id', flex: 1, minWidth: 140, maxWidth: 320,
		// 	cellClassName: 'space-cutter-class', filterable: false,
		// },
		{
			field: 'name', headerName: 'Name', flex: 1, minWidth: 120, maxWidth: 140,
			cellClassName: 'space-cutter-class', filterable: false,
			valueGetter: (params) => params?.row?.orig_emp?.fullName
		},
		{
			field: 'date', headerName: 'Shift Date', flex: 1, minWidth: 100, maxWidth: 140,
			cellClassName: 'space-cutter-class', filterable: false,
			valueGetter: (params) => moment(params?.row?.Shift_Date).format('MM-DD-YYYY')
		},
		{
			field: 'type', headerName: 'Shift Type', flex: 1, minWidth: 100, maxWidth: 120,
			cellClassName: 'space-cutter-class', filterable: false,
			renderCell: (params) => {
				return (
					<Chip
						label={params?.row?.shift?.Shift}
						className={params?.row?.shift?.Shift_Code == 2 ? 'day-chip' : 'night-chip'}
					/>
				)
			}
		},
		{
			field: 'action', headerName: 'Action', flex: 1, minWidth: 100, maxWidth: 120,
			cellClassName: 'space-cutter-class', filterable: false,
			renderCell: (params) => {
				if (params?.row?.patch_id)
					return (
						<Link to={`/firehouse/watch-party-work/${params?.row?.Batch_Number}/${params?.row?.patch_id}`}>
							<Chip
								variant="outlined"
								sx={{
									backgroundColor: '#BF1D2D',
									color: '#FFFFFF',
									border: '1px solid #BF1D2D',
									cursor: 'pointer'
								}}
								avatar={<Avatar src="/images/eye1.png" style={{ width: 28, height: 24, padding: 2 }} />}
								label={'View Shift'}
							/>
						</Link>
					)
			}
		},
	];

	let loadData = () => {
		setLoading(true);
		ApiService.get('/getOvertimeShiftsList')
			.then(({ data }) => {
				let tempArr = data.data.map((emp, i) => { return { ...emp, id: i } })
				setRows(tempArr);
				setLoading(false);
			}).catch((e) => {
				setLoading(false);
				toast.error("Error")
			})
	}

	useEffect(() => {
		loadData()
	}, [])

	return (
		<>
			<Box style={{ marginTop: "1rem" }}>

				<Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>
					<Grid item xs={12}>
						{loading &&
							<Paper className="w-100 d-flex justify-content-center align-items-center py-4"
								style={{ height: '410px' }}>
								<CircularProgress />
							</Paper>
						}

						{!loading &&
							<Paper className="p-3" sx={{ maxWidth: '93vw', overflowX: 'auto', background: '#FFF' }}>
								<Grid item xs={10} md={2.5} className='mb-2'>
									<Typography variant="h5">Watch Party</Typography>
								</Grid>
								{rows && rows.length > 0 ?
									<MyTable
										rows={rows}
										columns={columns}
										checkboxSelection={false}
										hideFooter={true}
									/>
									:
									<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 530 }}>
										<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
										<span className='mt-4' style={{ color: '#555555' }}>No Data</span>
									</div>
								}
							</Paper>
						}
					</Grid>
				</Grid>
			</Box>
		</>)
}
